import * as THREE from 'three';
import { ToolTypes, ToolState } from '../../globals';

export interface UIRenderData
{
	labels: ToolLabel[];
	interactiveHandles: ToolHandle[];
}

export interface ToolUIRenderInfo
{
	visible: boolean;
	color: THREE.Color;
	position: THREE.Vector3;
	renderPosition?:  THREE.Vector2;
}

export interface ToolHandle extends ToolUIRenderInfo
{
	id: number;
}

export interface ToolLabel extends ToolUIRenderInfo
{
	text: string;
	interactiveHandles: ToolHandle[];
}

export default abstract class BaseTool extends THREE.Object3D
{
	abstract getLabelWidth() : number;
	abstract getLabelHeight() : number;
	abstract getInteractiveHandleSize() : number;

	abstract setHighlightEnabled(enabled : boolean) : void;
	abstract setInteractableHandleId(id : number) : void;
	abstract forceFinalize() : void;
	abstract update() : void;

	abstract toolType : ToolTypes;
	abstract UIRenderData : UIRenderData;

	protected _isActive = false;
	protected _sceneViewId? : string;
	protected _state : ToolState = ToolState.InitialPlacement;

	public get state() : ToolState
	{
		return this._state;
	}

	public set state(value : ToolState)
	{
		this._state = value;
	}
	
	public get isActive() : boolean
	{
		return this._isActive;
	}

	public set isActive(value : boolean)
	{	
		this._isActive = value;
	}

	public get sceneViewId() : string | undefined
	{
		return this._sceneViewId;
	}

	public set sceneViewId(value : string | undefined)
	{
		this._sceneViewId = value;
	}
	
	constructor()
	{
		super();
	}
}


